import PropTypes from 'prop-types'
import { cn } from '@/lib/utils'

function InputFieldContainer({ label, children, className, labelClassName }) {
  return (
    <div className={cn('flex flex-col items-start self-stretch gap-1.5', className)}>
      <div className="flex flex-col items-start self-stretch gap-1.5">
        <p 
          className={cn('text-sm font-semibold text-[--base-black]', labelClassName)} 
          style={labelClassName?.includes('text-[14px]') ? { color: '#232429' } : undefined}
        >
          {label}
        </p>
        {children}
      </div>
    </div>
  )
}

InputFieldContainer.propTypes = {
  label: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.element]),
  className: PropTypes.string,
  labelClassName: PropTypes.string,
}

export { InputFieldContainer }
